import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MyContext } from '../context/MyContext';

import hyappLogo from '../resource/hyapp/logo.svg';
import haccproLogo from '../resource/haccpro/logo.svg';

import { useTranslation } from '../locale/useTranslation';
import { getLanguage } from '../locale/local';

function TopBar() {
  const { t, language, setLanguage } = useTranslation();
  const { loggedUser } = useContext(MyContext);
  const location = useLocation();

  const availableLocales = process.env.REACT_APP_AVAILABLE_LOCALES.split(",");
  return (

    <nav className="navbar is-white is-fixed-top" role="navigation">
      <div className="navbar-brand" style={{justifyContent: 'space-between', width: '100%'}}>
        <a className="navbar-item" title="Hÿapp" href="/">
          {
            process.env.REACT_APP_APP_VARIANT === "hyapp" ? <img src={hyappLogo} alt="Logo HyAPP" width="112" height="28" /> : null
          } 
          {
            process.env.REACT_APP_APP_VARIANT === "haccpro" ? <img src={haccproLogo} alt="Logo HACCPro" width="112" height="28" /> : null
          }           
        </a>
        <div className='navbar-end'>

          {
            loggedUser ? 
            (<Link to="/logout" className="navbar-item">{t("Se déconnecter")}</Link>)
            : 
            (<Link to="/login" className="navbar-item">{t("Se connecter")}</Link>)
          }
          {
            availableLocales.length > 1 ?
            (
              <div className="navbar-item has-dropdown is-hoverable">
                <a className="navbar-link">
                  {t(getLanguage())}
                </a>
                <div className="navbar-dropdown">
                  {
                    availableLocales.map((lang) => (
                      <a key={lang} className="dropdown-item" onClick={() => setLanguage(lang)}>{t(lang)}</a>
                    ))
                  }
                </div>
              </div>    
            )
            :null
          }      
        </div>
      </div>
    </nav>

  );
}

export default TopBar;